var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionalCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.55002C22.5 8.21002 21.96 8.75002 21.3 8.75002H3.7C3.04 8.75002 2.5 8.21002 2.5 7.55002V7.54002C2.5 5.25002 4.35 3.40002 6.64 3.40002H18.35C20.64 3.40002 22.5 5.26002 22.5 7.55002Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.45V16.46C2.5 18.75 4.35 20.6 6.64 20.6H18.35C20.64 20.6 22.5 18.74 22.5 16.45V11.45C22.5 10.79 21.96 10.25 21.3 10.25H3.7C3.04 10.25 2.5 10.79 2.5 11.45ZM8.5 17.25H6.5C6.09 17.25 5.75 16.91 5.75 16.5C5.75 16.09 6.09 15.75 6.5 15.75H8.5C8.91 15.75 9.25 16.09 9.25 16.5C9.25 16.91 8.91 17.25 8.5 17.25ZM15 17.25H11C10.59 17.25 10.25 16.91 10.25 16.5C10.25 16.09 10.59 15.75 11 15.75H15C15.41 15.75 15.75 16.09 15.75 16.5C15.75 16.91 15.41 17.25 15 17.25Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionalCard);
export default __webpack_public_path__ + "97120/static/media/TransactionalCard.08507ef63b71cd32123a88a5355127e0.svg";
export { ForwardRef as ReactComponent };